<template>
  <div>
    <!-- 房源详情 -->
    <div class="TagList">
      <el-tag
        data-num="21"
        ref="dataNum"
        :disable-transitions="false"
        @click="changeMenu(0)"
        :effect="TagsValue == 0 ? 'dark' : 'plain'"
      >
        房源预览
      </el-tag>
      <el-tag
        :disable-transitions="false"
        @click="changeMenu(1)"
        :effect="TagsValue == 1 ? 'dark' : 'plain'"
        v-if="premission('Calendar:Room:State')"
      >
        房态日历
      </el-tag>
      <el-tag
        :disable-transitions="false"
        @click="changeMenu(2)"
        :effect="TagsValue == 2 ? 'dark' : 'plain'"
        v-if="premission('Calendar:House:price')"
      >
        房价日历
      </el-tag>
      <el-tag
        :disable-transitions="false"
        @click="changeMenu(3)"
        :effect="TagsValue == 3 ? 'dark' : 'plain'"
        v-if="premission('Management:Listings')"
      >
        渠道管理
      </el-tag>
        <el-tag
            :disable-transitions="false"
            @click="changeMenu(4)"
            :effect="TagsValue == 4 ? 'dark' : 'plain'"
            v-if="premission('Management:Listings')"
        >
            直销管理
        </el-tag>
<!--      <el-tag-->
<!--        :disable-transitions="false"-->
<!--        @click="changeMenu(4)"-->
<!--        :effect="TagsValue == 4 ? 'dark' : 'plain'"-->
<!--        v-if="premission('Service:log')"-->
<!--      >-->
<!--        服务日志-->
<!--      </el-tag>-->
    </div>
    <HousingPreview v-if="TagsValue == 0"></HousingPreview>
    <channel v-if="TagsValue == 3"></channel>
      <housing-selling v-if="TagsValue == 4"></housing-selling>
  </div>
</template>

<script>
import HousingPreview from "../../components/productDetailsList/HousingPreview";
import channel from "../../components/productDetailsList/channel.vue";
import housingSelling from "@/components/productDetailsList/housingSelling";
import premission from "../../utils/permission";
export default {
  mixins: [premission],
  components: {
    HousingPreview,
    channel,housingSelling
  },
  data() {
    return {
      TagsValue: "0"
    };
  },
  created() {
    if (this.$route.params.houseId) {
      sessionStorage.setItem("houseId", this.$route.params.houseId);
    }
    //房东id
      if (this.$route.params.customerId) {
          sessionStorage.setItem("customerId", this.$route.params.customerId);
      }

  },
  methods: {
    changeMenu(e) {
      this.TagsValue = e;
    }
  }
};
</script>

<style lang="less" scoped>
.TagList {
  height: 46px;
  border-bottom: 1px solid #e1e1e1;
}
.el-tag--plain {
  cursor: pointer;
  width: 96px;
  height: 36px;
  line-height: 34px;
  font-size: 16px;
  text-align: center;
  margin-right: 50px;
  border: 1px solid #e1e1e1;
  color: #666666;
}
.el-tag--dark {
  cursor: pointer;
  width: 96px;
  height: 36px;
  line-height: 34px;
  font-size: 16px;
  text-align: center;
  margin-right: 50px;
}
</style>
